import Typography from '@material-ui/core/Typography';

function ChatIcon() {
    return (
        <Typography>
            <flos-icon shape="avatar-colored" size="40" style={{ marginBottom: '20px', padding: '0 8px' }} />
        </Typography>
    );
}

export { ChatIcon };
